// extracted by mini-css-extract-plugin
export default {"slideItem":"Slider_slideItem__8Jg04"};